// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"43cd259a7b66a611","931":"033cfef3ce1a10d2"}[chunkId] + ".css";
};